import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidatePhoneNumberUserQuery } from './usePhoneNumberUserQuery';
import { invalidateZoomImportablePhoneNumbersQuery } from './useZoomImportablePhoneNumbersQuery';

export function useRemoveZoomPhoneNumberMutation({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: (data: Api.ITelephonyConfiguration) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ id }: { id: string }) =>
			userSession.webServiceHelper.callAsync<Api.ITelephonyConfiguration>(`PhoneNumber/zoom/${id}`, 'DELETE'),
		onError,
		onSuccess,
		onSettled: () => {
			invalidatePhoneNumberUserQuery();
			invalidateZoomImportablePhoneNumbersQuery();
			onSettled?.();
		},
	});
}
